{
  "version": 1,
  "asset_id": "a235dda6-a567-4bea-ad4e-c2399ba9bc43",
  "project_id": "160b2239-3b67-4000-8b6e-d774982b0968",
  "url": "/__l5e/assets-v1/a235dda6-a567-4bea-ad4e-c2399ba9bc43/dr-sara-reflective-arch.jpg",
  "r2_key": "a/v1/160b2239-3b67-4000-8b6e-d774982b0968/a235dda6-a567-4bea-ad4e-c2399ba9bc43/dr-sara-reflective-arch.jpg",
  "original_filename": "dr-sara-reflective-arch.jpg",
  "size": 38785,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T07:27:01Z"
}
